import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SoftButton from "components/SoftButton";
import { useAuth0 } from "@auth0/auth0-react";
import { deleteQuery } from "api/UdasWrapper";
import { toast } from "react-toastify";
import { useRoles } from "hooks/useRoles";
import { Link } from "react-router-dom";
import SoftTypography from "components/SoftTypography";
import { ThemedMoreHorizIcon } from "assets/CXFIcons/Actions";

export const RoleActions = ({ selectedRole }) => {
	const { handleFetchRoles } = useRoles(false);
	const [roleActionsMenu, setRolesActionsMenu] = useState(null);
	const [openDialog, setOpenDialog] = useState(false);
	const { user } = useAuth0();

	const handleOpenRoleActionsMenu = (event) => {
		setRolesActionsMenu(event.currentTarget);
	};

	const handleClose = () => {
		setOpenDialog(false);
	};

	const handleCloseRoleActionsMenu = () => setRolesActionsMenu(null);

	const handleDeletionOnDatabase = async (id) => {
		let dataForDelete = JSON.stringify({
			query: `mutation DeleteRoles($tenant_id: String!, $deleteRolesId: String!) {
            deleteRoles(tenant_id: $tenant_id, id: $deleteRolesId) {
              isSuccessful
              message
              resultObject
            }
          }`,
			variables: { tenant_id: user?.stripeId, deleteRolesId: id }
		});
		try {
			const response = await deleteQuery(dataForDelete);
			if (response?.deleteRoles?.resultObject) {
				toast.success("Role deleted successfully!");
			}
			handleFetchRoles();
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<SoftBox>
			<Tooltip
				title="More Actions"
				placement="top"
			>
				<IconButton
					variant="text"
					size="medium"
					color="text"
					sx={{
						borderRadius: "10px"
					}}
					onClick={handleOpenRoleActionsMenu}
				>
					<ThemedMoreHorizIcon
						width={20}
						height={20}
					/>
				</IconButton>
			</Tooltip>
			<Menu
				anchorEl={roleActionsMenu}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right"
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "left"
				}}
				open={Boolean(roleActionsMenu)}
				onClose={handleCloseRoleActionsMenu}
				keepMounted
			>
				<MenuItem width="100%">
					<Link
						style={{ display: "block", width: "100%" }}
						to={`/administration/roles-and-permissions/${selectedRole?.id}`}
					>
						<SoftTypography
							variant="button"
							fontWeight="regular"
							color="text"
							sx={{ whiteSpace: "nowrap" }}
						>
							View role
						</SoftTypography>
					</Link>
				</MenuItem>
			</Menu>
			<Dialog
				open={openDialog}
				onClose={handleClose}
				fullWidth
			>
				<DialogTitle>Delete role</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Do you want to delete this{" "}
						<strong>{selectedRole?.name}</strong> role?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<SoftButton
						onClick={handleClose}
						color="primary"
						variant="outlined"
					>
						Cancel
					</SoftButton>
					<SoftButton
						onClick={() => {
							(handleDeletionOnDatabase(selectedRole.id), handleClose());
						}}
						color="primary"
					>
						Delete
					</SoftButton>
				</DialogActions>
			</Dialog>
		</SoftBox>
	);
};
